export default __webpack_public_path__ + "static/media/29.85d85467.jpeg";